interface BankDetailsFieldsGroupProps {
  children: React.ReactNode;
}

export function BankDetailsFieldsGroup({ children }: BankDetailsFieldsGroupProps) {
  return <div className='flex w-full max-w-xl flex-col gap-4'>{children}</div>;
}
